import React from 'react';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    // only scroll to top when transitioning to different page name
    if (this.props.location.pathname.split('/')[1] !== prevProps.location.pathname.split('/')[1]) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
